// extracted by mini-css-extract-plugin
module.exports = {"tabPanel":"tabPanel__SZ6c-"};